<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          緊急速報メールは「訓練」においても住民のスマートフォン等に送信します。（住民のスマートフォンに緊急速報メールが通知されます。）<br />
          送信の際は要否をご確認の上、実施してください。
        </p>
        <p
          v-if="evacuationOrderScreenMode.isDuplicate()"
          style="margin: 5px 0 15px 0"
        >
          以下を編集してください。
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-if="!evacuationOrderScreenMode.isView()"
              v-model="submitItem.disasterNo"
              :items="unfinishedDisasters"
              :rules="[rules.required]"
              label="災害名称"
              placeholder="選択してください"
              item-text="disaster_name"
              item-value="disaster_no"
              outlined
              @change="changeDisaster"
              :disabled="checkDeliveryStatus()"
            >
            </v-select>
            <v-text-field
              v-else
              :value="disasterName"
              label="災害名称"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="3" md="8" lg="6">
            <v-select
              v-if="!evacuationOrderScreenMode.isView()"
              v-model="submitItem.deliveryArea"
              :items="municipalities"
              :rules="[rules.requiredMultiple]"
              label="配信先エリア"
              placeholder="選択してください"
              multiple
              clearable
              outlined
              :disabled="checkDeliveryStatus()"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="selectAllToggle">
                  <v-list-item-action>
                    <v-icon>
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      全て
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
            <v-text-field
              v-else
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-btn
              v-if="!evacuationOrderScreenMode.isView()"
              class="mx-2 mt-3"
              @click="markPazUpz"
              color="primary"
              :disabled="isDisabled('PAZ_UPZ')"
              >PAZ及びUPZ
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              v-if="!evacuationOrderScreenMode.isView()"
              class="mx-2 mt-3"
              @click="showTempleteDialog = true"
              color="primary"
              >テンプレート選択
            </v-btn>
          </v-col>
        </v-row>
        <p style="margin: 5px 0 5px 10px">
          以下の情報を配信することはできません。<br />
          ・電話番号／メールアドレス／URL<br />
          ・環境依存文字（「①」等）やJIS第三水準以降（「﨑」等）の文字<br />
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              v-if="evacuationOrderScreenMode.isView()"
              v-model="submitItem.deliveryTitle"
              label="件名"
              placeholder=" "
              disabled
            >
            </v-text-field>
            <v-text-field
              v-else
              v-model="submitItem.deliveryTitle"
              label="件名"
              placeholder="入力してください"
              v-bind="formControlProps(15)"
              outlined
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-dialog v-model="showTempleteDialog">
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
              <v-toolbar dense color="white">
                <v-toolbar-title>テンプレート選択</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="templateHeaders"
                :items="templateItems"
                :items-per-page="-1"
                class="elevation-1 mt-2"
                hide-default-footer
                no-data-text="テンプレートはありません。"
              >
                <template v-slot:[`item.select`]="{ item }">
                  <v-btn class="mx-2" color="primary" @click="selectLanguage(item)">
                    選択
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="showTempleteDialog = false"
                >キャンセル</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="8">
            <v-textarea
              v-model="submitItem.deliveryBody"
              label="通知文"
              :placeholder="
                evacuationOrderScreenMode.isView() ? ' ' : '入力してください'
              "
              counter="200"
              maxlength="200"
              :outlined="!evacuationOrderScreenMode.isView()"
              :disabled="evacuationOrderScreenMode.isView()"
              :rules="[rules.required]"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-row>
      <v-col>
        <v-btn
          :disabled="isDisabled('SUBMIT')"
          @click="submit()"
          class="mx-2"
          color="primary"
        >
          送信
        </v-btn>
        <v-btn
          
          :disabled="isDisabled('TEMPORARILY_SAVED')"
          @click="execute('1')"
          class="mx-2"
          color="primary"
        >
          一時保存
        </v-btn>
        <v-btn class="mx-2" color="primary" @click="onClickReturn">
          キャンセル
        </v-btn>
      </v-col>
    </v-row>

    <select-urls
      ref="selectUrls"
      :isShowSelect="!evacuationOrderScreenMode.isView()"
      :isShowAgreeButton="!evacuationOrderScreenMode.isView()"
    />
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog";
import SelectUrls from "@/components/SelectUrls";
import config from "@/js/const";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { EvacuationOrderScreenMode } from "@/js/value-objects/evacuation-order-screen-mode";

Vue.use(Disaster);

const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);

const LALERT_MESSAGE =
  "緊急速報メールを発信すると、指定した配信先の住民へ一斉に通知され、取消しできません。\n本当に送信してもよろしいですか？";

const disasterStaffMstRepository = RepositoryFactory.get("disasterStaffMst");
const systemInfoRepository = RepositoryFactory.get("systemInfo");

const DELIVERY_STATUS_NON = "0"; //未配信
const DELIVERY_STATUS_LIVE = "1"; //配信中

export default {
  mixins: [messageUtils],
  components: {
    SelectUrls,
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({
    overlay: false,
    evacuationOrderScreenMode: "",
    screenId: "",
    screenTitle: "",
    category: "PAZ_UPZ",
    systemInfos: [],  //PAZ UPZ情報
    submitItem: {
      deliveryNo: "", // 配信番号
      disasterNo: "",
      emergCls: EmergencyClass.NL,
      hash: "", // ハッシュ値
      deliveryLevel: "", // 配信レベル
      deliveryCa: "LA",
      disasterCls: DisasterClass.P,
      deliveryStatus: "0",
      deliveryArea: [], // 配信先エリア
      deliveryTitle: "",
      deliveryBody: "",
      dests: [] // 配信エリアAPI送信用
    },
    uploadDialog: false,
    editedFileItems: [],
    config: config,
    urlCreateFlag: true,
    fixedPhrase: [],
    disasterDeliveryDetail: {},
    unfinishedDisasters: [
      {
        disaster_no: 0,
        disaster_name: ""
      }
    ],
    municipalities: [],
    rules: {
      required: value => !!value || "必須項目です。",
      requiredMultiple: value => value.length !== 0 || "必須項目です。"
    },
    showTempleteDialog: false,
    templateItems: []
  }),

  computed: {
    // ボタンの表示テキスト
    buttonText() {
      return function(buttonId) {
        let buttonText = "";
        switch (buttonId) {
          case "SUBMIT":
            buttonText = "送信";
            break;
          case "TEMPORARILY_SAVED":
            buttonText = "一時保存";
            break;
          case "DUPLICATE":
            buttonText = "コピーして編集";
            break;
          case "CANCEL":
            if (!this.evacuationOrderScreenMode.isView()) {
              buttonText = "キャンセル";
            } else {
              buttonText = "戻る";
            }
            break;
          default:
            break;
        }
        return buttonText;
      };
    },
    // ボタンの非活性制御（true：非活性、false：活性）
    isDisabled() {
      return function(buttonId) {
        let disabled = false;
        switch (buttonId) {
          case "SUBMIT":
            if (
              !this.submitItem.disasterNo ||
              this.submitItem.deliveryArea.length == 0 ||
              !this.submitItem.deliveryTitle ||
              !this.submitItem.deliveryBody
            ) {
              disabled = true;
            }
            break;
          case "TEMPORARILY_SAVED":
            if (!this.submitItem.disasterNo) {
              disabled = true;
            }
            break;
          case "DUPLICATE":
            break;
          case "CANCEL":
            break;
          case "PAZ_UPZ":
            if (
              this.submitItem.deliveryStatus === "1" ||   //配信中
              this.submitItem.deliveryStatus === "2" ||   //配信済
              this.submitItem.deliveryStatus === "3"      //配信失敗
              ) {  
                disabled = true;
              }
            break;
          default:
            break;
        }
        return disabled;
      };
    },

    // 災害名称（参照用）
    disasterName() {
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    },

    // 配信先エリア（参照用）
    parsedDeliveryArea() {
      const municipArray = [];
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    },

    // select templata
    templateHeaders() {
      return [
        {
          value: "template_id",
          text: "template id",
          align: " d-none"
        },
        {
          value: "select",
          text: "",
          width: "10%"
        },
        {
          value: "phrase_name",
          text: "テンプレート名称",
          align: ""
        },
        {
          value: "emergency_class",
          text: "緊急事態区分",
          align: ""
        },
        {
          value: "title",
          text: "件名",
          align: ""
        },
        {
          value: "contents",
          text: "本文",
          align: ""
        }
      ];
    },

    // 配信先エリアが全部選択されている状態の有無
    selectAllMunicip() {
      return this.submitItem.deliveryArea.length === this.municipalities.length;
    },
 
    // セレクトボックスの一部が選択されているかをチェック
    selectMunicip() {
      return this.submitItem.deliveryArea.length > 0 && !this.selectAllMunicip;
    },
 
    // セレクトボックスの「全て」アイコン
    icon() {
      if (this.selectAllMunicip) return "mdi-close-box"; // ×
      if (this.selectMunicip) return "mdi-minus-box"; // -
      return "mdi-checkbox-blank-outline"; // 空白
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // Set the ID & Screen name
      this.evacuationOrderScreenMode = EvacuationOrderScreenMode.factory(this.$route.name);
      this.screenId = this.evacuationOrderScreenMode.getScreenId();
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);

      // 災害情報
      await this.$store
        .dispatch("disasterInfo/loadDisasterInfo", this.screenId)
        .then(() => {
          // 災害情報（未終結）
          this.unfinishedDisasters = this.$store.state.disasterInfo.unfinished.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // 「編集」「コピーして編集」の場合
      // 災害配信情報
      if(this.evacuationOrderScreenMode.isEdit() || this.evacuationOrderScreenMode.isDuplicate()){
        await disasterDeliveryDetailRepository
          .list(this.screenId, this.delivery_no)
          .then(res => {
            this.disasterDeliveryDetail = res.data.results[0];
          })
          .catch(e => {
            this.handleError(e, this.screenId, "evacuation-order-management");
          });
      }

      // 定型文情報
      await this.$store
        .dispatch("fixedPhrase/loadFixedPhrase", this.screenId)
        .then(() => {
          this.fixedPhrases = this.$store.state.fixedPhrase.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // ログインユーザ情報
      await disasterStaffMstRepository
        .ownList(this.screenId)
        .then((res) => {
          this.disasterStaff = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });

      // システムマスタ情報（PAZ UPZ）
      await systemInfoRepository
        .list(this.screenId, this.category)
        .then(res => {
          this.systemInfos = res.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management")
        });

      // 編集・コピーして編集時
      if (
        this.evacuationOrderScreenMode.isEdit() ||
        this.evacuationOrderScreenMode.isDuplicate()
      ) {
        // 各値設定
        this.submitItem.deliveryNo = this.disasterDeliveryDetail.delivery_no;
        this.submitItem.emergCls = this.disasterDeliveryDetail.emerg_cls;
        this.submitItem.hash = this.disasterDeliveryDetail.hash;
        this.submitItem.delivery_lev = this.disasterDeliveryDetail.delivery_lev;
        if (arrayCount(this.disasterDeliveryDetail.dests) > 0) {
          this.disasterDeliveryDetail.dests.forEach(dest => {
            this.submitItem.deliveryArea.push(dest.municip_code);
          });
        }
        this.submitItem.deliveryTitle = this.disasterDeliveryDetail.delivery_title;
        this.submitItem.deliveryBody = this.disasterDeliveryDetail.delivery_body;
        this.submitItem.deliveryStatus = this.evacuationOrderScreenMode.isDuplicate() ? "0" : this.disasterDeliveryDetail.delivery_status;
        // 災害番号
        const detailsItem = this.unfinishedDisasters.find(
          obj => obj.disaster_no === this.disasterDeliveryDetail.disaster_no
        );
        if (detailsItem) {
          this.submitItem.disasterNo = detailsItem.disaster_no;
        } else {
          this.submitItem.disasterNo = "";
        }
      } else {
        // 新規登録時 災害番号
        const item = this.unfinishedDisasters.find(
          obj => obj.disaster_no === this.$disaster.disaster_no
        );
        this.submitItem.disasterNo = item ? item.disaster_no : "";
      }
      // 緊急事態区分テキストボックス/災害区分
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
      this.overlay = false;

      // テンプレート情報設定
      if (arrayCount(this.fixedPhrases) > 0) {
        this.fixedPhrases.forEach(fixedPhrase => {
          // 緊急速報メールの配列を取得
          if (fixedPhrase.delivery_ca === "LA" ) {
            let pushItem = {
              phrase_name: fixedPhrase.template_name,
              emergency_class: fixedPhrase.emerg_cls,
              title: fixedPhrase.phrases.filter(
                e => e.locale === "ja"
              )[0].title,
              contents: fixedPhrase.phrases.filter(
                e => e.locale === "ja"
              )[0].phrase,
            };
            this.templateItems.push(pushItem);
          }
        });
      };
    },

    // ボタン表示制御
    isVisible(buttonId) {
      let visible = false;
      switch (buttonId) {
        case "SUBMIT":
          if (
            this.evacuationOrderScreenMode.isEdit() ||
            this.evacuationOrderScreenMode.isCreate() ||
            this.evacuationOrderScreenMode.isDuplicate()
          ) {
            visible = true;
          }
          break;
        case "TEMPORARILY_SAVED":
          if (
            this.evacuationOrderScreenMode.isEdit() ||
            this.evacuationOrderScreenMode.isCreate() ||
            this.evacuationOrderScreenMode.isDuplicate()
          ) {
            visible = true;
          }
          break;
        case "CANCEL":
          visible = true;
          break;
        default:
          break;
      }
      return visible;
    },
    // ボタン押下時処理
    async onClick(buttonId) {
      switch (buttonId) {
        case "SUBMIT":
          this.submit();
          break;
        case "TEMPORARILY_SAVED":
        case "CANCEL":
          this.$router.push("/evacuation-order");
          break;
        default:
          break;
      }
    },

    // 送信ボタン押下時処理
    async submit() {
      let message = "送信先に所属市町村以外のエリアも選択されています。\n" +
          "送信してもよろしいですか?";
      let noticeMessage = "緊急速報メールは「訓練」においても住民のスマートフォン等に送信します。（住民のスマートフォンに緊急速報メールが通知されます。）\n" +
          "送信の際は要否をご確認の上、実施してください。"

      if (this.isNotArea()) {
        const result = await this.$refs.confirmSubmit.open(message, "送信", null);
        if (!result) {
          return;
        }
      }
      const noticeResult = await this.$refs.confirmSubmit.open(noticeMessage, "送信", null);
        if (!noticeResult) {
          return;
        }
      const result = await this.$refs.confirmSubmit.open(LALERT_MESSAGE, "送信", null);
        if (!result) {
          return;
        }
      this.execute();
    },

    // 送信・一時保存処理
    async execute(temporarilySaved = "0") {
      this.overlay = true;
      if (
        //「新規登録」「コピーして編集」の場合
        // 登録処理
        this.evacuationOrderScreenMode.isDuplicate() ||
        this.evacuationOrderScreenMode.isCreate()
      ) {
        this.submitItem.deliveryStatus =
          temporarilySaved === "1" ? DELIVERY_STATUS_NON : DELIVERY_STATUS_LIVE; // 配信ステータス判定
        this.executeCreateApi();
      } else if (
        //「編集」の場合
        // 更新処理
        this.evacuationOrderScreenMode.isEdit()
      ) {
        this.submitItem.deliveryStatus =
          temporarilySaved === "1" ? DELIVERY_STATUS_NON : DELIVERY_STATUS_LIVE; // 配信ステータス判定
        this.executeUpdateApi();
      } 
      this.overlay = false;
      // this.$router.push("/evacuation-order");
    },

    // キャンセルボタン押下時処理
    onClickReturn() {
      this.$router.push("/evacuation-order");
    },

    // 災害名称セレクトボックス変更時
    changeDisaster(value) {
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === value
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
    },

    // 登録処理
    async executeCreateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      this.setDests();
      let payload = this.toCreatePayload( this.submitItem );
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 登録API呼び出し
      await disasterDeliveryDetailRepository
        .create(ScreenId.SF0308, payload)
        .then(response => {
          this.handleSuccess(response, "evacuation-order-management");
        })
        .catch(e => {
          this.handleError(
            e,
            this.screenId,
            "evacuation-order-management"
          );
        });
    },

    // 更新処理
    async executeUpdateApi() {
      // API実行前処理
      // 入力情報をAPI形式に変換
      this.setDests();
      let payload = this.toUpdatePayload( this.submitItem );
      this.deleteItem(payload); // 不要項目削除（1件も存在しない場合はキー自体設定しない）
      this.clearMessage();

      // 更新API呼び出し
      await disasterDeliveryDetailRepository
        .update(ScreenId.SF0308, payload)
        .then(response => {
          this.handleSuccess(response, "evacuation-order-management");
        })
        .catch(e => {
          this.handleError(
            e,
            this.screenId,
            "evacuation-order-management"
          );
        });
    },

    //テンプレート選択
    selectLanguage(item) {
      this.submitItem.deliveryTitle = item.title;
      this.submitItem.deliveryBody = item.contents;
      this.showTempleteDialog = false;
      return;
    },

    // 配信先エリア判定 対象外に配信先エリアを含む true
    isNotArea() {
      let isNotAreaFlg = false;
      this.submitItem.deliveryArea.forEach(area => {
        if (area !== this.disasterStaff.municip_code) {
          isNotAreaFlg = true;
        }
      });
      return isNotAreaFlg;
    },

    // 配信先エリア設定（API形式に変換）
    setDests() {
      this.submitItem.dests = [];
      this.submitItem.deliveryArea.forEach(item => {
        let mapItem = {
          municip_code: item
        };
        this.submitItem.dests.push(mapItem);
      });
    },

    // 不要項目削除（1件も存在しない場合はキー自体設定しない）
    deleteItem(payloadItem) {
      // 配信先エリアが空の場合はキー項目削除
      if (payloadItem.dests.length === 0) {
        this.$delete(payloadItem, "dests");
      }
    },

    //登録処理用ペイロード作成
    toCreatePayload(item) {
    let retPayload = {
      disaster_no: item.disasterNo, // 災害番号
      emerg_cls: item.emergCls, // 緊急事態区分
      delivery_ca: "LA", // 配信先キャリア（"LA"固定）
      disaster_cls: item.disasterCls, // 災害区分 （"P"固定）※送信時は本番モードのみ
      delivery_status: item.deliveryStatus, // 配信ステータス
      delivery_title: item.deliveryTitle, // 配信タイトル
      delivery_body: item.deliveryBody, // 配信内容
      dests: item.dests // 配信先エリア
    };
    return retPayload;
    },

    //編集処理用ペイロード作成
    toUpdatePayload(item) {
    let retPayload = {
      delivery_no: item.deliveryNo, // 配信番号
      disaster_no: item.disasterNo, // 災害番号
      emerg_cls: item.emergCls, // 緊急事態区分
      hash: item.hash, // ハッシュ値
      delivery_lev: item.delivery_lev, // 配信レベル
      disaster_cls: item.disasterCls, // 災害区分 （"P"固定）※送信時は本番モードのみ
      delivery_status: item.deliveryStatus, // 配信ステータス
      delivery_title: item.deliveryTitle, // 配信タイトル
      delivery_body: item.deliveryBody, // 配信内容
      translation_status_en: item.translationStatusEn, // 翻訳ステータス(英語)
      translation_status_ko: item.translationStatusKo, // 翻訳ステータス(韓国語)
      translation_status_zh_cn: item.translationStatusZhCn, // 翻訳ステータス(中簡体)
      translation_status_zh_tw: item.translationStatusZhTw, // 翻訳ステータス(中繫体)
      dests: item.dests // 配信先エリア
    };
    return retPayload;
    },

    //PAZ及びUPZチェック処理
    markPazUpz() {
      this.submitItem.deliveryArea = [];
      this.municipalities.forEach(manicipality => {
        this.systemInfos.forEach(systemInfo => {
          if (manicipality.value === systemInfo.value) {
            this.submitItem.deliveryArea.push(manicipality.value);
          };
        });
      });  
    },

    //配信状況が「配信済み」「配信失敗」「配信中」かチェック
    //「配信済み」「配信失敗」「配信中」のいずれかならtrueを返す(非活性)
    checkDeliveryStatus() {
      let disabled = false;
      disabled = ["1", "2", "3"].includes(this.submitItem.deliveryStatus);
      return disabled;  //1:配信済み, 2:配信失敗, 3:配信中
    },
    
    // 配信先エリアの「全て」チェック処理
    selectAllToggle() {
      this.$nextTick(() => {
        if (this.selectAllMunicip) {
          this.submitItem.deliveryArea = [];
        } else {
          this.submitItem.deliveryArea = [];
          this.municipalities.forEach(manicipality => {
            this.submitItem.deliveryArea.push(manicipality.value);
          });
        }
      });
    }
  },
  
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 10000);
    }
  }
};
</script>

<style scoped>
.list-file-name {
  color: black;
}
</style>
